import namespace from "@rdfjs/namespace";
export const lvont = namespace("http://lexvo.org/ontology#");
